import { useEffect, useRef, useState } from "react";
import { tracks } from "./fakeData";

// import components
import DisplayTrack from "./DisplayTrack";
import Controls from "./Controls";
import ProgressBar from "./ProgressBar";
import TopBar from "./TopBar";
import useEventListener from "@use-it/event-listener";
import { Box } from "@mui/material";

const AudioPlayer = (props) => {
  //https://github.com/Ibaslogic/react-audio-player/tree/main
  // states
  const [trackIndex, setTrackIndex] = useState(0);
  const [currentTrack, setCurrentTrack] = useState(tracks[trackIndex]);
  const [timeProgress, setTimeProgress] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);
  const ESCAPE_KEYS = ["ArrowRight", "ArrowLeft", " "];

  // reference
  const audioRef = useRef();
  const progressBarRef = useRef();

  const handleNext = () => {
    if (trackIndex >= tracks.length - 1) {
      setTrackIndex(0);
      setCurrentTrack(tracks[0]);
    } else {
      setTrackIndex((prev) => prev + 1);
      setCurrentTrack(tracks[trackIndex + 1]);
    }
  };

  const handlePrevious = () => {
    if (trackIndex === 0) {
      let lastTrackIndex = tracks.length - 1;
      setTrackIndex(lastTrackIndex);
      setCurrentTrack(tracks[lastTrackIndex]);
    } else {
      setTrackIndex((prev) => prev - 1);
      setCurrentTrack(tracks[trackIndex - 1]);
    }
  };

  const handlerEventsKeyboard = (e) => {
    // console.log(e.key);
    e.preventDefault();
    if (ESCAPE_KEYS.includes(String(e.key))) {
      if (e.key === " " || e.keyCode === 32) {
        togglePlayPause();
      }
      if (e.key === "ArrowRight" || e.keyCode === 39) {
        handleNext();
      }
      if (e.key === "ArrowLeft" || e.keyCode === 37) {
        handlePrevious();
      }
      // console.log(`Escape key '${e.key} - ${e.keyCode}' pressed!`);
    }
  };
  useEventListener("keydown", handlerEventsKeyboard);

  const togglePlayPause = () => {
    setIsPlaying((prev) => !prev);
  };

  useEffect(() => {
    // DOMException: play() failed because the user didn't interact with the document first.
    setIsPlaying(true);
  }, []);

  useEffect(() => {
    // DOMException: play() failed because the user didn't interact with the document first.
    togglePlayPause();
  }, [props.external]);

  return (
    <>
      {/* <TopBar /> */}
      <Box sx={{ display: "none" }} className="audio-player">
        <Box className="inner">
          <DisplayTrack
            {...{
              currentTrack,
              audioRef,
              setDuration,
              progressBarRef,
              handleNext,
            }}
          />
          <Controls
            {...{
              isPlaying,
              audioRef,
              progressBarRef,
              duration,
              setTimeProgress,
              tracks,
              trackIndex,
              setTrackIndex,
              setCurrentTrack,
              handleNext,
              togglePlayPause,
            }}
          />
          <ProgressBar
            {...{ progressBarRef, audioRef, timeProgress, duration }}
          />
        </Box>
      </Box>
    </>
  );
};
export default AudioPlayer;
